import valid from '../valid.js'

export default button => {
  valid(button, {done: 1})
}
